<template>
    <div class='kbjs box noBtn'>
        <div class='jsy'>
            <p>本次开标到此结束！</p>
            <p>谢谢大家！</p>
        </div>
    </div>
</template>
<script>
export default {
    name:'kbjs',
    data(){
        return{
        }
    },
    methods:{
        getData(lx){
            console.log(lx)
        }
    }
}
</script>
<style lang="less">
.kbjs{
    position: relative;
    height: 100%;
    .jsy{
        font-size: 50px;
        font-weight: bold;
        color:#333;
        width: 500px;
        height:160px;
        text-align: center;
        line-height:80px;
        position: absolute;
        left: 50%;
        top:50%;
        margin-left:-250px;
        margin-top:-140px; 
    }
    .ewm{
        position: absolute;
        left:30px;
        bottom:20px;
        line-height: 83px;
        font-size: 18px;
        color:#333;
        img{
            width: 83px;
            height:83px;
            vertical-align:bottom;
            margin-right: 10px;
        }
    }
    .logo{
        position: absolute;
        width: 150px;
        height: 50px;
        right:30px;
        bottom:20px;
        line-height: 50px;
        background:url('../assets/images/logo2.png') no-repeat center;
    }
}
</style>